import { useQuotationTypeView } from "@/hooks/useQuotationTypeView";

const OPTIONS = [
  { value: "all", label: "Total" },
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
];

/**
 * Shopify-style segmented toggle for [Total | Online | Offline].
 * Selection is persisted via useQuotationTypeView so all analytics modules share it.
 *
 * Props (all optional):
 *  - testId: prefix for data-testid attributes on each segment
 *  - className: extra classes applied to the wrapper
 */
export default function QuotationTypeToggle({ testId = "qtype-toggle", className = "" }) {
  const [view, setView] = useQuotationTypeView();

  return (
    <div
      className={`inline-flex items-center rounded-md border border-[#E8E8E8] bg-slate-50 p-0.5 ${className}`}
      role="tablist"
      aria-label="Quotation type filter"
      data-testid={`${testId}-root`}
    >
      {OPTIONS.map((opt) => {
        const active = view === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => setView(opt.value)}
            data-testid={`${testId}-${opt.value}`}
            className={`px-3 h-7 text-xs font-medium rounded transition-colors ${
              active
                ? "bg-white text-[#0F0F0F] shadow-sm border border-[#E8E8E8]"
                : "text-[#1A1A1A]/60 hover:text-[#0F0F0F]"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
